import { useState } from "react";
import { PaymentMethodData } from "../../../../../__generated__/globalTypes";

export type PaymentMethodState = {
  isValid: boolean;
  data?: PaymentMethodData;
};

const usePaymentMethodState = () => {
  return useState<{
    isValid: boolean;
    data?: PaymentMethodData;
  }>({ isValid: false });
};

export default usePaymentMethodState;
